module.exports = __webpack_public_path__ + "static/media/how-to-use-food-waste-for-good.c7964b41.jpg";